import { render, staticRenderFns } from "./TableGroup.vue?vue&type=template&id=8b9f0856"
import script from "./TableGroup.vue?vue&type=script&lang=js"
export * from "./TableGroup.vue?vue&type=script&lang=js"
import style0 from "./TableGroup.vue?vue&type=style&index=0&id=8b9f0856&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports